import type { LucideIcon } from "lucide-react";
import {
  ClipboardList,
  Clock,
  FileText,
  ListChecks,
} from "lucide-react";

import type { PendingCounts } from "@/features/notifications/api/pendingCountsApi";

export type PendingActionKey =
  | "followups"
  | "grant_renewals"
  | "task_approvals"
  | "hours_pending";

export interface PendingActionItemConfig {
  key: PendingActionKey;
  title: string;
  subtitle: string;
  to: string;
  icon: LucideIcon;
}

/** Rows shown under “Needs action” in the notification panel (mock order). */
export const PENDING_ACTION_ITEMS: PendingActionItemConfig[] = [
  {
    key: "followups",
    title: "Case follow-ups due",
    subtitle: "Clients waiting on a check-in",
    to: "/cases",
    icon: ClipboardList,
  },
  {
    key: "grant_renewals",
    title: "Grant renewals due",
    subtitle: "Reporting or renewal deadlines passed",
    to: "/grants",
    icon: FileText,
  },
  {
    key: "task_approvals",
    title: "Task approvals waiting",
    subtitle: "Tasks waiting for a decision",
    to: "/tasks",
    icon: ListChecks,
  },
  {
    key: "hours_pending",
    title: "Hours waiting for approval",
    subtitle: "Submitted time needs a reviewer",
    to: "/time-tracker",
    icon: Clock,
  },
];

export function pendingActionRows(counts: PendingCounts | undefined): PendingActionItemConfig[] {
  if (!counts) return [];
  return PENDING_ACTION_ITEMS.filter((item) => (counts[item.key] ?? 0) > 0);
}

export function countForPendingAction(
  counts: PendingCounts | undefined,
  key: PendingActionKey,
): number {
  return counts?.[key] ?? 0;
}
